'use client';

import { Image } from '@coolblue-development/next-image/client';
import { useBreakpoints } from '@hooks/useBreakpoints';

type ProductImageProps = {
  primaryImage: {
    id: string;
  };
  name: string;
};

export default function ProductImage({ primaryImage, name }: ProductImageProps) {
  const { isMobile } = useBreakpoints();

  return (
    <Image
      imageId={primaryImage.id}
      fileCollection='product'
      width={isMobile ? 110 : 200}
      height={isMobile ? 100 : 160}
      background='transparent'
      objectFit='contain'
      alt={name || ''}
      loading='lazy'
      sizes='125px'
    />
  );
}
